import { Alert } from '@shared/components';
import { statusLabel } from '../utils/agreementStatus';
import type { AgreementStatus } from '../types/agreements.types';

interface Props {
    status: AgreementStatus | string;
}

/** Persistent inline warning, never a toast. Selection stays enabled in every
 *  non-active status; this only tells the dealer submission cannot proceed yet. */
export function InvoicingStatusWarning({ status }: Props) {
    if (status === 'active') {
        return null;
    }

    return (
        <Alert variant="warning">
            This agreement is {statusLabel(status)}. Invoicing cannot proceed until it is active.
        </Alert>
    );
}
